import { Fragment, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { default as ArrowDown } from '../../assets/images/angle_up_down.svg';
import HtmlAsText from '../createmode/HtmlAsText';
import { all as allBooks, single, show as singleBook } from '../../Store/api/books';
import MediaComponent from '../../components/createmode/MediaComponent';
import GrayledDropdown from '../../components/GrayledDropdown';
import arrow_down from '../../assets/images/angle_up_down.svg';
import { useLocation, useSearchParams } from 'react-router-dom';
import storage from '../../services/storage';
import { setActivities, replaceActivity, setBook } from '../../Store/entities/book';

import { byBook as gatActivitiesByBook, changeAssignedDate } from '../../Store/api/activities';
import SideBarHeader from '../studentDashboard/SideBarHeader/SideBarHeader';
import BookParagraph from '../../Pages/BookParagraph';

const GradeModeSideBar = ({
  setIsBookExpanded,
  scrollId,
  setScrollId,
  activities,
  activity,
  scrollChapter = () => {},
  lastBookId,
  scrollSection = () => {},
  currentActivity,
  notAllowed,
  setLink,
}) => {
  const user = storage.get('user');
  const [params] = useSearchParams();
  const bookID = params.get('bookId');
  const bookId = localStorage.getItem('lastBookId');
  const token = localStorage.getItem('xAuthToken');
  const [tabConent, setTabs] = useState('content');

  const classes = useSelector((state) => state.entities.classes);

  const emails = useSelector((state) => state.entities.instructors.instructors) || [];
  const { book, books = [] } = useSelector((state) => state.entities);
  const { reader } = useSelector((state) => state.ui.reader);
  const auth = useSelector((state) => state.auth);
  const { settings } = useSelector((state) => state.settings.settings);
  const [sideBar, setSideBar] = useState([]);
  const [sideBarSection, setSideBarSection] = useState([]);
  const [sideBarActivity, setSideBarActivity] = useState([]);
  const [subTab, setSubTab] = useState('all');
  const [showDatePicker, setShowDatePicker] = useState('');
  const [startDate, setStartDate] = useState('');
  const [activityDraggedOverElement, setActivityDraggedOverElement] = useState('');
  const { licenses } = useSelector((state) => state.entities.bookFelids.bookFields);

  const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
  /* No book Select */
  const location = useLocation();
  const isSignupFlow = location.pathname == `/signup/createclass`;
  //Create Class States
  const dispatch = useDispatch();
  const emailsMap = {};
  for (const email of emails) {
    emailsMap[email.email] = email;
  }
  const [modalShows, setModalShows] = useState(false);
  const handleClose = () => {
    setModalShows(false);
    // Your closing logic here...
  };
  const handleCustomClick = () => {};

  const datePickerHandler = (value, date) => {
    const datee = date
      ? new Date(date).toLocaleString('en-029')
      : new Date('1/1/1970').toLocaleString('en-029');
    setStartDate(datee);
    setShowDatePicker(value);
  };

  useEffect(() => {
    if (auth.token && (!user || user.role !== 'STUDENT')) {
      dispatch(
        allBooks({
          onSuccess: (res) => {
            dispatch(
              singleBook({
                id: bookId,
                onSuccess: (response) => {},
              })
            );
            dispatch(
              single({
                id: bookId || res.data.data[0]._id,

                onSuccess: (response) => {
                  dispatch(setBook(response.data.data.book));
                },
              })
            );
            dispatch(
              gatActivitiesByBook({
                id: bookId || res.data.data[0]._id,
                onSuccess: (res) => {},
              })
            );
          },
        })
      );
    }
  }, []);
  const dynamicChapterClass = (chapter, index) => {
    let className = 'accordion-button main_head chapter_element chapter-btn chapter_element_left';
    className += sideBar.includes(chapter.title) ? ' active' : ' collapsed';
    className += reader.chapter === index ? ' fw_700' : '';
    return className;
  };

  const dynamicSectionClass = (chapter, section, index, secIndex) => {
    let className = 'section-btn section_element section_element_left';

    className += sideBarSection.includes(`${chapter._id}-${section._id}`)
      ? ' accordion-button main_head active'
      : ' accordion-button main_head collapsed';

    return className;
  };
  const toggleSidebarSection = (e, value) => {
    e.stopPropagation();
    if (sideBarSection.includes(value)) {
      setSideBarSection(sideBarSection.filter((sec) => sec !== value));
    } else {
      setSideBarSection([...sideBarSection, value]);
    }
  };
  const toggleSidebarActivity = (e, value) => {
    if (sideBarActivity.includes(value)) {
      setSideBarActivity(sideBarActivity.filter((e) => e !== value));
    } else {
      setSideBarActivity([...sideBarActivity, value]);
    }
  };
  const expendSidebar = (e, value) => {
    e.stopPropagation();
    if (sideBar.includes(value)) {
      setSideBar(sideBar.filter((e) => e !== value));
    } else {
      setSideBar([...sideBar, value]);
    }
  };

  // const renderChapters = () => (
  //   <div className='tab-pane fade show active custom_tabs_chapater'>
  //     <div className='accordion' id='accordion_active'>
  //       {book.chapters?.map((chapter, index) => (
  //         <div key={index}>
  //           <div className={`accordion-item`}>
  //             <h2 className='accordion-header'>
  //               <div className={dynamicChapterClass(chapter, index)} type='button' aria-expanded={sideBar.includes(chapter.title) ? true : false} aria-controls='panelsStayOpen-collapsePreface' data-id={chapter._id}>
  //                 {'    '}{' '}
  //                 <div className='chap_title'>
  //                   <span className='eclipses'>
  //                     <HtmlAsText htmlContent={chapter.title} />
  //                   </span>
  //                   <img onClick={(e) => expendSidebar(e, chapter.title)} src={ArrowDown} alt='arrow' />
  //                 </div>
  //               </div>
  //             </h2>
  //             <div
  //               // id="panelsStayOpen-collapsePreface"
  //               className={sideBar.includes(chapter.title) ? 'accordion-collapse collapse show' : 'accordion-collapse collapse'}
  //               aria-labelledby='panelsStayOpen-Preface'
  //             >
  //               {/* <div className="accordion-body">
  //                 <p className="f14">{chapter.description}</p>
  //               </div> */}
  //               <div className='accordion-body bl' style={{ marginLeft: '8px' }}>
  //                 {chapter.sections.map((section, secIndex) => {
  //                   const sectActivities = activities.filter((e) => e?.sections?.includes(section._id) && !e.paragraphs.length);
  //                   const sectActivity = sectActivities[0];
  //                   return (
  //                     <div key={secIndex} className='section_element'>
  //                       <div className='accordion-item'>
  //                         <h2
  //                           className='accordion-header'
  //                           // id="panelsStayOpen-Biological"
  //                         >
  //                           <button
  //                             className={dynamicSectionClass(chapter, section, index, secIndex)}
  //                             // className={
  //                             //   sideBarSection.includes(
  //                             //     `${chapter._id}-${section._id}`
  //                             //   )
  //                             //     ? "accordion-button  main_head  active"
  //                             //     : "accordion-button  main_head  collapsed"
  //                             // }
  //                             data-id={`${chapter._id}.${section._id}`}
  //                             type='button'
  //                             data-bs-toggle='collapse'
  //                             aria-expanded={sideBarSection.includes(`${chapter._id}-${section._id}`)}
  //                           >
  //                             <div className='chap_title'>
  //                               <span className='eclipses sects'>
  //                                 <HtmlAsText htmlContent={section.title} />
  //                               </span>
  //                               <img onClick={(e) => toggleSidebarSection(e, `${chapter._id}-${section._id}`)} src={ArrowDown} alt='arrow' />
  //                             </div>
  //                           </button>
  //                           <div className={sideBarSection.includes(`${chapter._id}-${section._id}`) ? 'accordion-collapse collapse show' : 'accordion-collapse collapse'} aria-labelledby='panelsStayOpen-Biological'>
  //                             <div className='accordion-body bl'>
  //                               {section.paragraphs.map((paragraph, parIndex) => {
  //                                 const pActivities = activities.filter((e) => e.paragraphs.includes(paragraph._id));
  //                                 const pActivity = pActivities[0];
  //                                 return (
  //                                   <div key={parIndex}>
  //                                     <div className='accordion-item p-element'>
  //                                       <h2 className={`accordion-header`}>
  //                                         <div className='accordion-body' style={{ marginTop: '8px' }}>
  //                                           <div>
  //                                             <p className={`left-ps`}>
  //                                               <a className={`cursor eclipses ps ${activities.findIndex((e) => e.paragraphs.includes(paragraph._id)) > -1 && 'purple'}`}>
  //                                                 <HtmlAsText htmlContent={paragraph.text || 'Paragraph'} />
  //                                               </a>
  //                                             </p>
  //                                           </div>
  //                                         </div>
  //                                       </h2>
  //                                     </div>
  //                                   </div>
  //                                 );
  //                               })}
  //                             </div>
  //                           </div>
  //                         </h2>
  //                       </div>
  //                     </div>
  //                   );
  //                 })}
  //               </div>
  //             </div>
  //           </div>
  //         </div>
  //       ))}
  //     </div>
  //   </div>
  // );

  const renderChapters = () => {
    return (
      <div
        className='tab-pane fade show active custom_tabs_chapater'
        // onMouseLeave={() => {
        //   setActivityDraggedOverElement('');
        // }}
      >
        <h1 className='f-16 mini_title book-title-left'>{book?.title || ''}</h1>

        <div className='accordion mb-0' id='accordion_active' style={{ marginTop: '0px' }}>
          {book.chapters.map((chapter, index) => {
            const chapActivities = book.activities.filter(
              (e) => e.chapter === chapter._id && !e.section
            );
            const chapActivity = chapActivities[0];

            return (
              <div key={index}>
                <div className={`accordion-item`}>
                  <h2 className='accordion-header'>
                    <div
                      // onMouseEnter={() => {
                      //   if (isDraggingActivity) {
                      //     setActivityDraggedOverElement(chapter._id);
                      //   }
                      // }}
                      // onMouseUp={() => {
                      //   if (isDraggingActivity) {
                      //     const draggedActivityIndex = book.activities.findIndex((e) => e._id === draggedActivity._id);

                      //     dispatch(
                      //       changeAssignment({
                      //         id: draggedActivity._id,
                      //         body: { chapter: chapter._id },
                      //         onSuccess: (res) => {
                      //           dispatch(
                      //             replaceActivity({
                      //               activity: {
                      //                 ...draggedActivity,
                      //                 chapter: chapter._id,
                      //                 section: '',
                      //                 paragraphs: [],
                      //               },
                      //               index: draggedActivityIndex,
                      //             })
                      //           );
                      //         },
                      //         onError: (error) => {},
                      //       })
                      //     );
                      //   }
                      //   setActivityDraggedOverElement('');
                      // }}
                      className={dynamicChapterClass(chapter, index)}
                      type='button'
                      aria-controls='panelsStayOpen-collapsePreface'
                      data-id={chapter._id}
                      aria-expanded={sideBar.includes(chapter.title) ? true : false}
                      style={{ padding: '0px' }}
                    >
                      {'    '}{' '}
                      <div
                        style={{
                          borderRadius: '2px',
                          padding: '4px  6px 4px 2px',
                        }}
                        className={`chap_title ${sideBar.includes(chapter._id) ? 'bg_grey' : ''}`}
                        onClick={(e) => {
                          scrollChapter(chapter?._id, index);
                          expendSidebar(e, chapter._id);
                          setIsBookExpanded(true);
                        }}
                      >
                        <span
                          className='
                          eclipses
                          '
                        >
                          <HtmlAsText htmlContent={chapter.title} />
                        </span>
                        {chapter?.sections?.length > 0 && (
                          <img
                            src={arrow_down}
                            alt='arrow'
                            style={{
                              cursor: 'pointer',
                              transform: sideBar.includes(`${chapter?._id}`)
                                ? 'rotate(180deg)'
                                : 'rotate(0deg)',
                              transition: 'transform 0.3s ease',
                            }}
                            onClick={(e) => {
                              expendSidebar(e, chapter._id);
                            }}
                          />
                        )}
                      </div>{' '}
                    </div>
                  </h2>

                  <div
                    style={{
                      marginBottom: chapter.sections.length > 0 ? '8px' : '0px',
                    }}
                    // id="panelsStayOpen-collapsePreface"
                    className={
                      sideBar.includes(chapter._id)
                        ? 'accordion-collapse collapse show'
                        : 'accordion-collapse collapse'
                    }
                    aria-labelledby='panelsStayOpen-Preface'
                  >
                    {/* <div className="accordion-body">
                      <p className="f14">{chapter.description}</p>
                    </div> */}
                    <div
                      className='accordion-body bl'
                      style={{
                        marginLeft: '5px',
                        marginTop: chapter.sections.length > 0 ? '10px' : '0px',

                        display: chapter.sections.length > 0 ? 'flex' : 'none',
                        flexDirection: 'column',
                        gap: '8px',
                      }}
                    >
                      {book.activities
                        .filter((e) => e.chapter === chapter?._id && !e.section)
                        .map((e, index) => (
                          <div key={index} className='section_element'>
                            <div className='accordion-item'>
                              <h2 className='accordion-header'>
                                <button
                                  style={{
                                    textTransform: 'capitalize',
                                    margin: '0px 1px 0px 16px',
                                    padding: '0px 0px',
                                    fontWeight: '400',
                                  }}
                                  className={dynamicChapterClass(chapter, index)}
                                  data-id={`${chapter._id}`}
                                  type='button'
                                  data-bs-toggle='collapse'
                                  aria-expanded={sideBarSection.includes(`${chapter._id}`)}
                                >
                                  <div
                                    className='purple'
                                    style={{ fontWeight: '400' }}
                                    onClick={(e) => {
                                      scrollChapter(chapter?._id);
                                      toggleSidebarSection(e, `${chapter._id}`);
                                      setIsBookExpanded(true);
                                    }}
                                  >
                                    <HtmlAsText
                                      htmlContent={e.title}
                                      style={{ fontWeight: '400' }}
                                    />
                                  </div>{' '}
                                </button>
                              </h2>
                            </div>
                          </div>
                        ))}
                      {chapter.sections.map((section, secIndex) => {
                        const sectActivities = book.activities.filter(
                          (e) => e.section === section._id && !e.paragraphs.length
                        );
                        const sectActivity = sectActivities[0];
                        return (
                          <div key={secIndex} className='section_element'>
                            <div className='accordion-item'>
                              <h2
                                className='accordion-header'
                                // id="panelsStayOpen-Biological"
                              >
                                <button
                                  style={{
                                    textTransform: 'capitalize',
                                    margin: '0px 1px 0px 16px',
                                    padding: '3px 0px',
                                  }}
                                  className={dynamicSectionClass(
                                    chapter,
                                    section,
                                    index,
                                    secIndex
                                  )}
                                  // className={
                                  //   sideBarSection.includes(
                                  //     `${chapter._id}-${section._id}`
                                  //   )
                                  //     ? "accordion-button  main_head  active"
                                  //     : "accordion-button  main_head  collapsed"
                                  // }
                                  data-id={`${chapter._id}.${section._id}`}
                                  type='button'
                                  data-bs-toggle='collapse'
                                  aria-expanded={sideBarSection.includes(
                                    `${chapter._id}-${section._id}`
                                  )}
                                >
                                  <div
                                    className='chap_title'
                                    onClick={(e) => {
                                      scrollSection(`${chapter._id}.${section._id}`);
                                      toggleSidebarSection(e, `${chapter._id}-${section._id}`);
                                      setIsBookExpanded(true);
                                    }}
                                  >
                                    <HtmlAsText htmlContent={section.title} />
                                    {(book.activities.some(
                                      (e) => e.section === section._id && !e.paragraph
                                    ) ||
                                      section?.paragraphs?.some((p) =>
                                        book.activities.some((e) => e.paragraphs?.includes(p._id))
                                      )) && (
                                      <img
                                        onClick={(e) =>
                                          toggleSidebarSection(e, `${chapter._id}-${section._id}`)
                                        }
                                        src={
                                          sideBarSection.includes(`${chapter._id}-${section._id}`)
                                            ? arrow_down
                                            : arrow_down
                                        }
                                        alt='arrow'
                                        style={{ cursor: 'pointer' }}
                                      />
                                    )}
                                  </div>{' '}
                                  {/* {sectActivities.length > 0 && showDatePicker !== `${section._id}` && (
                                      <div
                                        className='mini-text'
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          datePickerHandler(section._id, setActivities.assignedDate);
                                        }}
                                      >
                                        {miniChapText(sectActivities)}
                                      </div>
                                    )} */}
                                </button>
                                {(book.activities.some(
                                  (e) => e.section === section._id && !e.paragraph
                                ) ||
                                  section?.paragraphs?.some((p) =>
                                    book.activities.some((e) => e.paragraphs?.includes(p._id))
                                  )) && (
                                  <div
                                    className={
                                      sideBarSection.includes(`${chapter._id}-${section._id}`)
                                        ? 'accordion-collapse collapse show'
                                        : 'accordion-collapse collapse'
                                    }
                                    aria-labelledby='panelsStayOpen-Biological'
                                  >
                                    <div
                                      className='accordion-body bl'
                                      style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '8px',
                                      }}
                                    >
                                      {book.activities
                                        .filter((e) => e.section === section._id && !e.paragraph)
                                        .map((e, index) => (
                                          <div key={index} className='section_element'>
                                            <div className='accordion-item'>
                                              <h2 className='accordion-header'>
                                                <button
                                                  style={{
                                                    textTransform: 'capitalize',
                                                    margin: '0px 1px 0px 16px',
                                                    padding: '0px 0px',
                                                    fontWeight: '400',
                                                  }}
                                                  className={dynamicSectionClass(
                                                    section,
                                                    section,
                                                    index
                                                  )}
                                                  data-id={`${section._id}`}
                                                  type='button'
                                                  data-bs-toggle='collapse'
                                                  aria-expanded={sideBarSection.includes(
                                                    `${chapter._id}-${section._id}`
                                                  )}
                                                >
                                                  <div
                                                    className='purple'
                                                    style={{ fontWeight: '400' }}
                                                    onClick={(e) => {
                                                      scrollSection(
                                                        `${chapter?._id}.${section?._id}`
                                                      );
                                                      toggleSidebarSection(
                                                        e,
                                                        `${chapter._id}.${section._id}`
                                                      );
                                                      setIsBookExpanded(true);
                                                    }}
                                                  >
                                                    <HtmlAsText
                                                      htmlContent={e.title}
                                                      style={{ fontWeight: '400' }}
                                                    />
                                                  </div>{' '}
                                                </button>
                                              </h2>
                                            </div>
                                          </div>
                                        ))}
                                      {/* {section?.paragraphs &&
                                      section.paragraphs.map((paragraph) => {
                                        const pActivity = book.activities.find((e) => e.paragraphs.includes(paragraph._id));
                                        return (
                                          paragraph.text && (
                                            <div key={paragraph._id}>
                                              <div className='accordion-item p-element'>
                                                <h2 className='accordion-header'>
                                                  <div className='accordion-body' style={{ marginTop: '0px' }}>
                                                    <div>
                                                      <p className='left-ps mb-0'>
                                                        <a
                                                          style={{
                                                            marginBottom: '0px',
                                                            fontWeight: '500',
                                                            textTransform: 'default',
                                                            pointerEvents: 'auto',
                                                            color: 'inherit',
                                                          }}
                                                          className={`cursor eclipses ps ${book.activities.findIndex((e) => e.paragraphs.includes(paragraph._id)) > -1 && 'purple'}`}
                                                          onClick={(e) => {
                                                            e.preventDefault();
                                                            dispatch(setChapter(index));
                                                            dispatch(setSection(secIndex));
                                                            if (anchorBook) anchorBook(chapter._id, section._id, paragraph._id);
                                                          }}
                                                        >
                                                          <HtmlAsText htmlContent={paragraph.text || 'Paragraph'} />
                                                        </a>
                                                      </p>
                                                    </div>
                                                  </div>
                                                </h2>
                                              </div>
                                            </div>
                                          )
                                        );
                                      })} */}
                                    </div>
                                  </div>
                                )}
                              </h2>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const renderNewActivities = () => {
    return (
      <div className='Contents_tabs custom_tabs_chapater'>
        {' '}
        {book?.activities
          ?.filter((e) => e.book === book?.book?._id)
          .map((activity, actIndex) => (
            <div
              className='accordion-item activity-element'
              key={activity.chapter + '.' + activity.section + '.' + actIndex}
            >
              <h2 className='accordion-header activity-element'>
                <div
                  // className={
                  //   sideBarActivity.includes(`${chapter._id}-${section._id}-${activity._id}`) ? "accordion-button active main_head fw_700" : "accordion-button collapsed main_head fw_700"
                  // }
                  className={`${
                    sideBarActivity.includes(
                      `${activity.chapter}-${activity.section}-${activity._id}`
                    )
                      ? 'accordion-button active main_head fw_700'
                      : 'accordion-button main_head fw_700 collapsed'
                  } ${activity.assigned ? 'assigned' : ''} activity-btn activity-element`}
                  type='button'
                  data-bs-toggle='collapse'
                  data-bs-target='#panelsStayOpen-collapseKnowledge'
                  aria-expanded={sideBarActivity.includes(
                    `${activity.chapter}-${activity.section}-${activity._id}`
                  )}
                  aria-controls='panelsStayOpen-collapseKnowledge'
                  onClick={(e) => {
                    toggleSidebarActivity(
                      e,
                      `${activity.chapter}-${activity.section}-${activity._id}`
                    );
                  }}
                >
                  <div className='chap_title activity-element'>
                    <span className='eclipses'>{activity.title}</span>
                    <img src={ArrowDown} alt='arrow' className='activity-element' />
                  </div>{' '}
                </div>
              </h2>
              <div
                // id="panelsStayOpen-collapseSubdisciplines"
                className={
                  sideBarActivity.includes(
                    `${activity.chapter}-${activity.section}-${activity._id}`
                  )
                    ? 'accordion-collapse collapse event-less show'
                    : 'accordion-collapse collapse event-less'
                }
                aria-labelledby='panelsStayOpen-Subdisciplines'
              >
                <div className='accordion-body event-less'>
                  {activity.questions.map((question, quesIndex) => (
                    <div key={quesIndex} className='event-less'>
                      <p className='event-less'>
                        <a className='event-less'>{question.text}</a>
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
      </div>
    );
  };
  return (
    <div>
      <GrayledDropdown mode={'teach'} notAllowed={notAllowed} setLink={setLink} />
      <div className='custom_nav'>
        <ul className='nav nav-tabs nav-justified' id='myTab' role='tablist'>
          <li className='nav-item' role='presentation'>
            <button
              className={tabConent === 'content' ? 'nav-link active' : 'nav-link'}
              id='home-tab'
              data-bs-toggle='tab'
              data-bs-target='#Contents'
              type='button'
              role='tab'
              aria-controls='Contents'
              aria-selected='true'
              onClick={(e) => {
                setIsBookExpanded(false);
                setTabs('content');
              }}
            >
              Contents
            </button>
          </li>
          <li className='nav-item' role='presentation'>
            <button
              className={tabConent === 'book' ? 'nav-link active' : 'nav-link'}
              id='classroom-tab'
              data-bs-toggle='tab'
              data-bs-target='#classroom'
              type='button'
              role='tab'
              aria-controls='profile'
              aria-selected='false'
              onClick={(e) => {
                setIsBookExpanded(true);
                setTabs('book');
              }}
            >
              book
            </button>
          </li>
        </ul>
        <div className='tab-content' id='myTabContent'>
          <div
            className={
              tabConent === 'content' ? 'tab-pane fade show active' : 'tab-pane fade show'
            }
            id='Contents'
            role='tabpanel'
            aria-labelledby='Contents-tab'
          >
            <div className='Contents_tabs'>
              <div className='tabs_content classroom_wrap' id='myContents'>
                {subTab === 'activities-chapters' ? (
                  <Fragment>
                    <div className='vh-50'>
                      <div
                        className='tab-pane fade show active custom_tabs_chapater'
                        aria-labelledby='all-tab'
                      >
                        {renderChapters()}
                      </div>
                    </div>
                    <div className='sidebar_subheading'>
                      <span> ACTIVITIES</span>
                    </div>
                    <hr />
                    <div className='vh-50'>{renderNewActivities()}</div>
                  </Fragment>
                ) : (
                  <Fragment>
                    <div
                      className='tab-pane fade show active custom_tabs_chapater'
                      aria-labelledby='all-tab'
                    >
                      {renderChapters()}
                    </div>
                  </Fragment>
                )}
              </div>
            </div>
          </div>
          <div
            className={
              tabConent === 'book'
                ? 'tab-pane fade show active sidebar_book'
                : 'tab-pane fade show sidebar_book'
            }
            id='book'
            role='tabpanel'
            aria-labelledby='book-tab'
          >
            <SideBarHeader mode={'grade-mode'} book={book} />
            <div className=''>
              <BookParagraph
                bookId={bookId}
                activity={activity}
                setTabs={setTabs}
                scrollId={scrollId}
                setScrollId={setScrollId}
                chapters={book.chapters}
                activities={activities}
              />
            </div>

            {/* <div className='sidebar_book_wrapper'>
              {book?.chapters
                .filter((e) => e._id === currentActivity?.chap?._id)
                .map((chapter, index) => (
                  <div key={index}>
                    <div dangerouslySetInnerHTML={{ __html: chapter.title }}></div>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: chapter.description,
                      }}
                    ></p>
                    {(currentActivity.sections ? [...chapter.sections.filter((e) => currentActivity?.sections?.includes(e._id))] : chapter.section)?.map((section, secIndex) => (
                      <div key={secIndex}>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: section.title,
                          }}
                        ></div>
                        {section.paragraphs?.map((paragraph, pIndex) => (
                          <div key={pIndex}>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: paragraph.text,
                              }}
                            ></div>
                            {paragraph.media && (
                              <Fragment>
                                {paragraph.media.map((media, mIndex) => (
                                  <MediaComponent chapterIndex={index} secInd={secIndex} pIndex={pIndex} setBook={() => {}} book={book} media={media} index={mIndex} parent={'paragraph'} parentId={paragraph._id} />
                                ))}
                              </Fragment>
                            )}
                             
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                ))}
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};
export default GradeModeSideBar;
